let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2KnQ4")).then(() => parcelRequire('5eKjD'));